/**
 * @generated SignedSource<<cc0cd49eb25b2367e2b3753368963aeb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "biId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessIdentityUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBusinessIdentityTPayload",
        "kind": "LinkedField",
        "name": "updateBusinessIdentityTByBiId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityT",
            "kind": "LinkedField",
            "name": "businessIdentityT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessIdentityUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBusinessIdentityTPayload",
        "kind": "LinkedField",
        "name": "updateBusinessIdentityTByBiId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessIdentityT",
            "kind": "LinkedField",
            "name": "businessIdentityT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "913064a5d598cc45ff15f16a0da7e248",
    "id": null,
    "metadata": {},
    "name": "BusinessIdentityUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessIdentityUpdateMutation(\n  $input: UpdateBusinessIdentityTByBiIdInput!\n) {\n  updateBusinessIdentityTByBiId(input: $input) {\n    businessIdentityT {\n      biId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c8aa16b7cf71938ddbd262ac5af43764";

module.exports = node;
